import { useTheme } from '../hooks/useTheme'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="w-[42px] h-[42px] rounded-chip flex items-center justify-center border border-studio-border hover:border-studio-border-strong transition-all duration-300 ease-studio cursor-pointer"
      style={{ background: 'var(--surface-2)' }}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      <span className="text-lg select-none" style={{ color: 'var(--text)' }}>
        {theme === 'dark' ? '◑' : '◐'}
      </span>
    </button>
  )
}
